// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

/* Same search look as the other lists */
.door-search {
  height: 44px;
  min-height: 0;
  margin-bottom: 14px;
  padding: 0;
  --border-radius: 10px;
  --box-shadow: none;
  --background: var(--ion-background-color, #fff);
}
.door-search ::ng-deep .searchbar-input-container {
  height: 100%;
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);
  border-radius: 10px;
}
.door-search ::ng-deep .searchbar-input {
  height: 100%;
  min-height: 0;
}
.door-search ::ng-deep .searchbar-search-icon {
  top: 50%;
  transform: translateY(-50%);
}

/* Doors: white rounded card, one row per door with a clear "Open" button */
.door-list {
  margin: 0;
  padding: 0;
  list-style: none;
  border-radius: 14px;
  overflow: hidden;
  background: var(--ion-background-color, #fff);
  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);
}
@media (max-width: 767px) {
  .door-list {
    margin: 0 -12px;
    border-radius: 0;
    border-left: 0;
    border-right: 0;
  }
}

.door-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 14px 12px 16px;
}
.door-row + .door-row {
  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);
}
.door-row__icon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  color: var(--ion-color-primary);
  background: rgba(var(--ion-color-primary-rgb), 0.12);
}
.door-row__icon i {
  font-size: 26px;
}
.door-row__name {
  flex: 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.door-row__open {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  height: 40px;
  padding: 0 16px;
  border: 0;
  border-radius: 10px;
  background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, transform 0.1s ease;
}
.door-row__open ion-icon {
  font-size: 18px;
}
.door-row__open:hover {
  background: var(--ion-color-primary-shade);
}
.door-row__open:active {
  transform: scale(0.97);
}
.door-row__open:focus-visible {
  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);
  outline-offset: 2px;
}
.door-row__open:disabled {
  cursor: not-allowed;
  color: var(--ion-color-medium);
  background: rgba(var(--ion-color-medium-rgb), 0.15);
  transform: none;
}
.door-row {
  /* Phones: icon-only button to leave room for the name */
}
@media (max-width: 400px) {
  .door-row__open span {
    display: none;
  }
  .door-row__open {
    width: 44px;
    padding: 0;
    justify-content: center;
  }
}

/* Offline: doors greyed out */
.door-list--offline .door-row__icon {
  color: var(--ion-color-medium);
  background: rgba(var(--ion-color-medium-rgb), 0.14);
}`, "",{"version":3,"sources":["webpack://./src/components/general components/list-environment-open-door/list-environment-open-door.component.scss","webpack://./src/components/general%20components/list-environment-open-door/list-environment-open-door.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;ACCF;;ADEA,wCAAA;AACA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,qBAAA;EACA,kBAAA;EACA,+CAAA;ACCF;ADCE;EACE,YAAA;EACA,yDAAA;EACA,mBAAA;ACCJ;ADEE;EACE,YAAA;EACA,aAAA;ACAJ;ADGE;EACE,QAAA;EACA,2BAAA;ACDJ;;ADKA,2EAAA;AACA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,6CAAA;EACA,yDAAA;ACFF;ADIE;EATF;IAUI,eAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;ECDF;AACF;;ADIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,4BAAA;ACDF;ADGE;EACE,6DAAA;ACDJ;ADIE;EACE,aAAA;EACA,mBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,oDAAA;ACFJ;ADII;EACE,eAAA;ACFN;ADME;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;ACJJ;ADOE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;EACA,oCAAA;EACA,wCAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4DAAA;ACLJ;ADOI;EACE,eAAA;ACLN;ADQI;EACE,0CAAA;ACNN;ADSI;EACE,sBAAA;ACPN;ADUI;EACE,0DAAA;EACA,mBAAA;ACRN;ADWI;EACE,mBAAA;EACA,8BAAA;EACA,mDAAA;EACA,eAAA;ACTN;AD9DA;EA2EE,wDAAA;ACVF;ADWE;EACE;IACE,aAAA;ECTJ;EDYE;IACE,WAAA;IACA,UAAA;IACA,uBAAA;ECVJ;AACF;;ADcA,8BAAA;AACA;EACE,8BAAA;EACA,mDAAA;ACXF","sourcesContent":[":host {\n  display: block;\n}\n\n/* Same search look as the other lists */\n.door-search {\n  height: 44px;\n  min-height: 0;\n  margin-bottom: 14px;\n  padding: 0;\n  --border-radius: 10px;\n  --box-shadow: none;\n  --background: var(--ion-background-color, #fff);\n\n  ::ng-deep .searchbar-input-container {\n    height: 100%;\n    border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n    border-radius: 10px;\n  }\n\n  ::ng-deep .searchbar-input {\n    height: 100%;\n    min-height: 0;\n  }\n\n  ::ng-deep .searchbar-search-icon {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n/* Doors: white rounded card, one row per door with a clear \"Open\" button */\n.door-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n\n  @media (max-width: 767px) {\n    margin: 0 -12px;\n    border-radius: 0;\n    border-left: 0;\n    border-right: 0;\n  }\n}\n\n.door-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px 12px 16px;\n\n  & + & {\n    border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n  }\n\n  &__icon {\n    display: grid;\n    place-items: center;\n    flex-shrink: 0;\n    width: 46px;\n    height: 46px;\n    border-radius: 50%;\n    color: var(--ion-color-primary);\n    background: rgba(var(--ion-color-primary-rgb), 0.12);\n\n    i {\n      font-size: 26px;\n    }\n  }\n\n  &__name {\n    flex: 1;\n    min-width: 0;\n    font-size: 15px;\n    font-weight: 600;\n    overflow-wrap: anywhere;\n  }\n\n  &__open {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    flex-shrink: 0;\n    height: 40px;\n    padding: 0 16px;\n    border: 0;\n    border-radius: 10px;\n    background: var(--ion-color-primary);\n    color: var(--ion-color-primary-contrast);\n    font: inherit;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background-color 0.15s ease, transform 0.1s ease;\n\n    ion-icon {\n      font-size: 18px;\n    }\n\n    &:hover {\n      background: var(--ion-color-primary-shade);\n    }\n\n    &:active {\n      transform: scale(0.97);\n    }\n\n    &:focus-visible {\n      outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n      outline-offset: 2px;\n    }\n\n    &:disabled {\n      cursor: not-allowed;\n      color: var(--ion-color-medium);\n      background: rgba(var(--ion-color-medium-rgb), 0.15);\n      transform: none;\n    }\n  }\n\n  /* Phones: icon-only button to leave room for the name */\n  @media (max-width: 400px) {\n    &__open span {\n      display: none;\n    }\n\n    &__open {\n      width: 44px;\n      padding: 0;\n      justify-content: center;\n    }\n  }\n}\n\n/* Offline: doors greyed out */\n.door-list--offline .door-row__icon {\n  color: var(--ion-color-medium);\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n}\n",":host {\n  display: block;\n}\n\n/* Same search look as the other lists */\n.door-search {\n  height: 44px;\n  min-height: 0;\n  margin-bottom: 14px;\n  padding: 0;\n  --border-radius: 10px;\n  --box-shadow: none;\n  --background: var(--ion-background-color, #fff);\n}\n.door-search ::ng-deep .searchbar-input-container {\n  height: 100%;\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.25);\n  border-radius: 10px;\n}\n.door-search ::ng-deep .searchbar-input {\n  height: 100%;\n  min-height: 0;\n}\n.door-search ::ng-deep .searchbar-search-icon {\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n/* Doors: white rounded card, one row per door with a clear \"Open\" button */\n.door-list {\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border-radius: 14px;\n  overflow: hidden;\n  background: var(--ion-background-color, #fff);\n  border: 1px solid rgba(var(--ion-color-medium-rgb), 0.18);\n}\n@media (max-width: 767px) {\n  .door-list {\n    margin: 0 -12px;\n    border-radius: 0;\n    border-left: 0;\n    border-right: 0;\n  }\n}\n\n.door-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 12px 14px 12px 16px;\n}\n.door-row + .door-row {\n  border-top: 1px solid rgba(var(--ion-color-medium-rgb), 0.12);\n}\n.door-row__icon {\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  width: 46px;\n  height: 46px;\n  border-radius: 50%;\n  color: var(--ion-color-primary);\n  background: rgba(var(--ion-color-primary-rgb), 0.12);\n}\n.door-row__icon i {\n  font-size: 26px;\n}\n.door-row__name {\n  flex: 1;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n.door-row__open {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  flex-shrink: 0;\n  height: 40px;\n  padding: 0 16px;\n  border: 0;\n  border-radius: 10px;\n  background: var(--ion-color-primary);\n  color: var(--ion-color-primary-contrast);\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, transform 0.1s ease;\n}\n.door-row__open ion-icon {\n  font-size: 18px;\n}\n.door-row__open:hover {\n  background: var(--ion-color-primary-shade);\n}\n.door-row__open:active {\n  transform: scale(0.97);\n}\n.door-row__open:focus-visible {\n  outline: 2px solid rgba(var(--ion-color-primary-rgb), 0.5);\n  outline-offset: 2px;\n}\n.door-row__open:disabled {\n  cursor: not-allowed;\n  color: var(--ion-color-medium);\n  background: rgba(var(--ion-color-medium-rgb), 0.15);\n  transform: none;\n}\n.door-row {\n  /* Phones: icon-only button to leave room for the name */\n}\n@media (max-width: 400px) {\n  .door-row__open span {\n    display: none;\n  }\n  .door-row__open {\n    width: 44px;\n    padding: 0;\n    justify-content: center;\n  }\n}\n\n/* Offline: doors greyed out */\n.door-list--offline .door-row__icon {\n  color: var(--ion-color-medium);\n  background: rgba(var(--ion-color-medium-rgb), 0.14);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
